import { Injectable, signal } from "@angular/core";
import type { BoatTelemetry } from "../../../simulation-core";

/**
 * Live boat telemetry signal, updated each frame from the rAF poll in
 * SceneCanvasComponent. Components read fields via `state()` (a plain
 * snapshot signal) and recompute via `computed` when they need derived
 * values like degrees or knots.
 *
 * One signal, replaced by reference each frame. Cheaper than ~12 separate
 * signals when ~all fields change every tick.
 */
@Injectable({ providedIn: "root" })
export class BoatTelemetryStore {
  readonly state = signal<BoatTelemetry | null>(null);

  /**
   * Update from sim. Skips signal write if the new value is identical to
   * the previous one within a small epsilon (rare in practice — boat is
   * almost always moving — but cheap to check).
   */
  update(t: BoatTelemetry): void {
    this.state.set(t);
  }
}
